import { PriceElementProps } from '../../types/components/pricing/PriceElement';

import { CoinsIcon } from '../../modules/Icons';

import creditsHelpers from '../../helpers/creditsHelpers';

import SavingsBadge from '../shared/SavingsBadge'

const PriceElement: React.FC<PriceElementProps> = (props) => {
  const { className, purchasedItem, showSavingsBadge, user } = props;
  const { getCreditPriceTextFor } = creditsHelpers;
  const [price, word] = getCreditPriceTextFor(purchasedItem).split(' ');

  if (purchasedItem.free_product) {
    return <></>;
  }

  const determineSavingsBadgeText = () => {
    return "Save up to 40%"
  }

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center">
      <div cy-test-id="price-element" className={`w-fit flex ${className || ''}`}>
        <CoinsIcon className="w-[32px] h-[32px] mr-2 stroke-white" />
        <span className="text-white inter">
          <span className="font-bold text-32 leading-32" cy-test-id="item-price">
            {price}{" "}
          </span>
          <span className="text-16 leading-28" cy-test-id="item-price-word">
            {word}
          </span>
        </span>
      </div>

      {/* Badge - will appear above on small screens and to the right on larger screens */}
      {showSavingsBadge && (
        <div cy-test-id="savings-badge" className="flex justify-end order-first mb-2 md:mb-4 md:ml-4 md:order-last">
          <SavingsBadge text={determineSavingsBadgeText()} />
        </div>
      )}
    </div>
  );
}

export default PriceElement;
